import { createContext } from "react";

const AlreadyVotedContext = createContext({
  alreadyVoted: false,
  setAlreadyVoted: () => {},
});

export default AlreadyVotedContext;
